import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import useIsMobile from '@/hooks/useIsMobile';
import { useLocation, useNavigate } from 'react-router-dom';
import * as S from './style';
import infoBanner from '@/assets/img/banner/team.png';
import { useState } from 'react';
import { useGetTeamApi } from '@/api/basic';

const Team = () => {
	const navigate = useNavigate();
	const isMoble = useIsMobile(900);
	const { data: teamData } = useGetTeamApi();
    
	return (
		<main>
			<SubBanner subTitle="Team" title="수십 년의 투자 운용 및 금융 서비스 경험을 갖춘 전문가들을 소개합니다." img={infoBanner} />
            <S.ConferenceContainer>
                <S.ConferenceTitle>
                    <>
                        조직구성
                        <br style={isMoble ? {} : { display: 'none' }} />
                    </>
                </S.ConferenceTitle>

                <S.TeamListSection>
                    <S.TeamCardGrid>
                        {teamData?.team?.map((team) => (
                            <S.TeamCard key={team.team_pk}>
                                <S.TeamCardContent>
                                    <S.TeamCardTop>
                                        <S.TeamCardHeader>
                                            <S.PositionBadge isCeo={team.team_position === '대표이사'}>
                                                <S.TeamCardPosition isCeo={team.team_position === '대표이사'}>{team.team_position}</S.TeamCardPosition>
                                            </S.PositionBadge>
                                        </S.TeamCardHeader>
                                        <S.TeamCardName>{team.team_name}</S.TeamCardName>
                                    </S.TeamCardTop>

                                    <S.TeamCardSpacer />

                                    <S.TeamCardBody>
                                        <S.ExperienceTitle>주요 경력</S.ExperienceTitle>
                                        <S.ExperienceList>
                                            {team.team_career.replace(/<\/?[^>]+(>|$)/g, "").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').split(",").map((exp, idx) => (
                                                <S.ExperienceItem key={idx}>
                                                    <S.ExperienceRow>
                                                        <S.BulletDot />
                                                        <span>{exp}</span>
                                                    </S.ExperienceRow>
                                                </S.ExperienceItem>
                                            ))}
                                        </S.ExperienceList>
                                    </S.TeamCardBody>
                                </S.TeamCardContent>
                            </S.TeamCard>
                        ))}
                    </S.TeamCardGrid>
                </S.TeamListSection>
            </S.ConferenceContainer>
		</main>
	);
};

export default Team;
